"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWidthUp = exports.isWidthDown = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var React = _interopRequireWildcard(require("react"));
var _createBreakpoints = require("../styles/createBreakpoints");
var _useTheme = require("../styles/useTheme");
var _getDisplayName = _interopRequireDefault(require("../testUtils/getDisplayName"));
var _useMediaQuery = require("../utilities/useMediaQuery");
const _excluded = ["initialWidth", "width"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// By default, returns true if screen width is the same or greater than the given breakpoint.
const isWidthUp = function (breakpoint, width) {
  let inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (inclusive) {
    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
  }
  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
};

// By default, returns true if screen width is the same or less than the given breakpoint.
exports.isWidthUp = isWidthUp;
const isWidthDown = function (breakpoint, width) {
  let inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (inclusive) {
    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
  }
  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
};
exports.isWidthDown = isWidthDown;
const useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
const withWidth = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (
    // @ts-ignore
    Component => {
      const {
        withTheme: withThemeOption = false,
        noSSR = false,
        initialWidth: initialWidthOption
      } = options;
      // not sure what type props should be
      function WithWidth(props) {
        const contextTheme = (0, _useTheme.useTheme)();
        const {
            initialWidth: initialWithProp,
            width
          } = props,
          other = (0, _objectWithoutProperties2.default)(props, _excluded);
        const theme = props.theme || contextTheme;
        const [mountedState, setMountedState] = React.useState(false);
        useEnhancedEffect(() => {
          setMountedState(true);
        }, []);

        /**
         * innerWidth |xs      sm      md      lg      xl
         *            |-------|-------|-------|-------|------>
         * width      |  xs   |  sm   |  md   |  lg   |  xl
         */
        const keys = theme.breakpoints.keys.slice().reverse();
        const widthComputed = keys.reduce((output, key) => {
          const matches = (0, _useMediaQuery.useMediaQuery)(theme.breakpoints.up(key));
          return !output && matches ? key : output;
        }, null);
        const finalWidth = width || (mountedState || noSSR ? widthComputed : undefined) || initialWithProp || initialWidthOption;
        const more = _objectSpread(_objectSpread({
          width: finalWidth
        }, withThemeOption ? {
          theme
        } : {}), other);

        // When rendering the component on the server,
        // we have no idea about the client browser screen width.
        // In order to prevent blinks and help the reconciliation of the React tree
        // we are not rendering the child component.
        //
        // An alternative is to use the `initialWidth` property.
        if (more.width === undefined) {
          return null;
        }

        // @ts-ignore
        return /*#__PURE__*/React.createElement(Component, more);
      }
      if (process.env.NODE_ENV !== 'production') {
        WithWidth.displayName = `WithWidth(${(0, _getDisplayName.default)(Component)})`;
      }
      (0, _hoistNonReactStatics.default)(WithWidth, Component);
      return WithWidth;
    }
  );
};
var _default = exports.default = withWidth;